module.exports = __webpack_public_path__ + "img/ltkholiday-4x.4c37678.jpg";